function loadChatWidget() {
    if (window.chatWidgetLoaded) return;
    window.chatWidgetLoaded = true;
  
    var cm = document.createElement('script');
    cm.type = 'text/javascript';
    cm.async = true;
    cm.src = 'https://kcsafexvff.chat.digital.ringcentral.com/chat/fa940f0c17c296dd51bd0bdd/loader.js';
    document.head.appendChild(cm);
  }
  
  window.addEventListener('scroll', loadChatWidget, { once: true });
  window.addEventListener('mousemove', loadChatWidget, { once: true });
  window.addEventListener('touchstart', loadChatWidget, { once: true });
  